import { FiltersContainer } from 'pages/Location/issues/styled';
import { memo } from 'react';
import { QuickFilterConfig, QuickFilterPane } from 'shared/filter_pane/QuickFilterPane';
import { PriorityFilter, SeverityFilter } from 'shared/issue_filters_context/types';
import { css } from 'styled-components';

const containerStyles = css`
    gap: 2rem;
`;

export type LocationIssuesFilters = Readonly<{
    statusFilters: string[];
    severityFilters: SeverityFilter[];
    priorityFilters: PriorityFilter[];
}>;

const quickFilters: QuickFilterConfig<LocationIssuesFilters>[] = [
    {
        id: 'new',
        label: 'New',
        value: ['new'],
        field: 'statusFilters',
        isArray: true,
    },
    {
        id: 'open',
        label: 'Open',
        value: ['open'],
        field: 'statusFilters',
        isArray: true,
    },
    {
        id: 'severe',
        label: 'Severe',
        value: ['severe'],
        field: 'severityFilters',
        isArray: true,
    },
    {
        id: 'high-priority',
        label: 'High Priority',
        value: ['critical', 'high'],
        field: 'priorityFilters',
        isArray: true,
    },
];

type LocationIssuesQuickFiltersProps = Readonly<{
    filters: LocationIssuesFilters;
    onChange: (filters: LocationIssuesFilters) => void;
}>;

function LocationIssuesQuickFilters({
    filters,
    onChange,
}: LocationIssuesQuickFiltersProps) {
    return (
        <QuickFilterPane
            id="location-issues-filter-pane"
            filters={filters}
            quickFilters={quickFilters}
            onChange={onChange}
            containerStyles={containerStyles}
        >
            <FiltersContainer />
        </QuickFilterPane>
    );
}

const memoLocationIssuesQuickFilters = memo(LocationIssuesQuickFilters);
export { memoLocationIssuesQuickFilters as LocationIssuesQuickFilters };
